import { requestInterceptors, SessionOutInterceptor, ReportRequestInterceptor, AbortRequestInterceptor } from '@tencent/wphk-base-request';
import { showDialog, hideDialog } from '@tencent/wphk-components-dialog';
import { i18n } from '../i18n';
import qs from 'qs';

/**
 * 默认登陆超时错误码
 */
const DEF_ERROR_CODES = ['51001097', '51001000', '8598998000'];

/**
 * 登陆态超时处理参数
 */
interface SessionOutOptions {
  /**
   * 登陆错误码列表，可不填
   */
  errCodes?: string[],
  /**
   * 登陆前处理，如关闭loading
   */
  beforeLogin?: () => void,
  /**
   * 页面登陆
   */
  login: () => void
};

/**
 * 处理登陆超时，引导重新登陆
 */
export default function initRequestInterceptors(options: {
  /**
   * 登陆态过期处理相关参数
   */
  sessionOut?: SessionOutOptions
}) {
  const { sessionOut } = options;
  if (sessionOut) {
    const { errCodes, beforeLogin, login } = sessionOut;
    requestInterceptors
      .use(new SessionOutInterceptor({
        errCodes: [... new Set(DEF_ERROR_CODES.concat(errCodes || []))],
        handle({ isLoggedIn }) {
          // 一般ajax请求前会先展示loading，由于登陆拦截会卡住后续流程，
          // 这里需要先手动关闭loading，避免loading和下面的登陆提示弹框同时出现
          if (beforeLogin) {
            beforeLogin();
          }
          // 操作引发的超时失效，需要弹框引导登录
          if (isLoggedIn) {
            showDialog({
              title: i18n('你的登录已失效，请重新登录。'),
              btns: [
                {
                  text: i18n('确定'),
                  click() {
                    hideDialog();
                    login();
                  },
                },
              ],
            });
            return;
          }
          // 页面初始化时登陆失效，直接去进行登陆操作
          login();
        },
      }));
  }
  // 添加通用的日志上报和请求中断拦截器
  requestInterceptors
    .use(new ReportRequestInterceptor())
    .use(new AbortRequestInterceptor());
}

/**
 * 刷新登陆页面，用于刷新模版页面重新登陆
 * @param keepHash 是否保留hash
 * @returns
 */
export function refreshLogin(options: { keepHash?: boolean } = { keepHash: false }) {
  const { search, href } = location;
  const baseUrl = href.split('?')[0];
  const searchStr = search.replace(/^\?/, '');
  let { hash } = location;
  const hashStr = hash.replace(/^#\//, '');
  if (!searchStr) {
    location.replace(href);
    return;
  }
  const urlParams = qs.parse(searchStr);
  // 删除code以便重新去Auth登陆
  delete urlParams.code;
  // 增加一个随机数确保url是新的能跳转
  urlParams.__v = `${Math.random()}`;
  // 如果需要保留hash，增加一个page参数
  const { keepHash } = options;
  if (!keepHash) {
    hash = '';
  } else if (hashStr) {
    urlParams.page = hashStr;
  }
  // 重新生成新的URL
  const url = `${baseUrl}?${qs.stringify(urlParams)}${hash}`;
  location.replace(url);
}

